import { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

export const CANCEL_REASONS = [
  "Verification Failed",
  "Requested by agent",
  "Order Modification",
  "Pincode Error",
  "Other",
];

export const VERIFICATION_FAILED_REMARKS = [
  "Call not connected",
  "Amount issue",
  "CX don't have any idea about order",
  "Cx don't want this order",
  "Wrong address",
  "Wrong number",
  "Cx don't want to pay shipping charge",
  "Rate Issue",
  "CX is out of station",
  "Other",
];

// Reason is always picked from CANCEL_REASONS. When reason is "Verification Failed",
// remark is also picked from a fixed dropdown (VERIFICATION_FAILED_REMARKS), with "Other"
// revealing a free-text box. For every other reason, remark stays a free-text field.
export default function CancelOrderReasonFields({
  reason,
  remark,
  onReasonChange,
  onRemarkChange,
  remarkRequired = false,
}) {
  const isVerificationFailed = reason === "Verification Failed";
  const [otherMode, setOtherMode] = useState(
    isVerificationFailed && remark && !VERIFICATION_FAILED_REMARKS.includes(remark)
  );

  useEffect(() => {
    if (!isVerificationFailed) {
      setOtherMode(false);
    }
  }, [isVerificationFailed]);

  const handleReasonChange = (e) => {
    onReasonChange(e.target.value);
    onRemarkChange("");
    setOtherMode(false);
  };

  const handleRemarkDropdownChange = (e) => {
    const val = e.target.value;
    if (val === "Other") {
      setOtherMode(true);
      onRemarkChange("");
    } else {
      setOtherMode(false);
      onRemarkChange(val);
    }
  };

  const dropdownValue = otherMode ? "Other" : VERIFICATION_FAILED_REMARKS.includes(remark) ? remark : "";

  return (
    <>
      <FormControl fullWidth required sx={{ mb: 2 }}>
        <InputLabel id="cancel-reason-label">Reason</InputLabel>
        <Select labelId="cancel-reason-label" label="Reason" value={reason} onChange={handleReasonChange}>
          {CANCEL_REASONS.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {isVerificationFailed ? (
        <>
          <FormControl fullWidth required={remarkRequired} sx={{ mb: otherMode ? 2 : 0 }}>
            <InputLabel id="cancel-remark-label">Remark</InputLabel>
            <Select
              labelId="cancel-remark-label"
              label="Remark"
              value={dropdownValue}
              onChange={handleRemarkDropdownChange}
            >
              {VERIFICATION_FAILED_REMARKS.map((r) => (
                <MenuItem key={r} value={r}>
                  {r}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {otherMode && (
            <TextField
              autoFocus
              label="Please specify remark"
              fullWidth
              multiline
              rows={2}
              value={remark}
              onChange={(e) => onRemarkChange(e.target.value)}
            />
          )}
        </>
      ) : (
        <TextField
          label={remarkRequired ? "Remark" : "Remark (Optional)"}
          fullWidth
          multiline
          rows={3}
          value={remark}
          onChange={(e) => onRemarkChange(e.target.value)}
        />
      )}
    </>
  );
}
